import '../../less/registration-candidate.less';
import CommonStatus from './CommonStatus';
import RegistrationCode422 from './codes/RegistrationCode422';

export default class Candidate extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { status, custom, modalProps, failureCallback } = this.props;

        switch(status) {
            case 409:
            case 410:
            case 412: 
                return <CommonStatus {...this.props} 
                    preComponentCallback={() => { if (failureCallback) failureCallback(status); }}
                />;

            case 422: 
                modalProps.width = 350;
                return (
                    <div>
                        <div className='ss-cmpts-reg-status-color-indicator-code-422' />
                        <RegistrationCode422 data={custom} />
                    </div>
                );
            
            default: return <CommonStatus {...this.props} />;
        }
    }
}